import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';

import SrIcon from 'client/components/SrIcon';
import SrLink from 'client/components/SrLink/SrLink';
import SrPhotosCarousel from 'client/components/SrPhotosCarousel';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

import SrButton, {
  SR_BUTTON_FONT_SIZE_SMALL,
  SR_BUTTON_HEIGHT_SHORTER,
  SR_BUTTON_THEME_ADOBE_YELLOW_TENANT_SCREENING_LISTING,
} from './SrButton/SrButton';

export const SR_PARTNER_LISTING_CARD_TAG_THEME_GREEN = 'tag-theme-green';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE = 'tag-theme-white';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_ORANGE = 'tag-theme-white-orange';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_GREY = 'tag-theme-white-grey';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_GREY_SUNSCREEN =
  'tag-theme-white-grey-sunscreen';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_RED_SUNSCREEN = 'tag-theme-red-sunscreen';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_BLACK = 'tag-theme-white-black';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_GREY_COOL = 'tag-theme-grey-cool';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_PURPLE = 'tag-theme-purple';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_YELLOW = 'tag-theme-yellow';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_ORANGE = 'tag-theme-orange';
export const SR_PARTNER_LISTING_CARD_TAG_THEME_BLUE = 'tag-theme-blue';

class SrPartnerListingCard extends Component {
  static propTypes = {
    to: PropTypes.string,
    photos: PropTypes.array.isRequired,
    disablePhotoCount: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.object.isRequired),
    title: PropTypes.string.isRequired,
    date: PropTypes.string,
    stats: PropTypes.array,
    caption: PropTypes.string,
    className: PropTypes.string,
    hasSelfTour: PropTypes.bool,
    has3DTour: PropTypes.bool,
    textToCopy: PropTypes.string,
    hideStatsView: PropTypes.bool,
    showViewWithTitle: PropTypes.bool,
    bottomChips: PropTypes.arrayOf(PropTypes.object.isRequired),
  };

  constructor(props) {
    super(props);
    this.state = {
      preloadAllSlideshowImages: false,
      copiedText: false,
    };
  }

  _onPreviousPhoto = () => {
    this.setState({
      preloadAllSlideshowImages: true,
    });
  };

  _onNextPhoto = () => {
    this.setState({
      preloadAllSlideshowImages: true,
    });
  };

  _onCopyClick = () => {
    const { textToCopy } = this.props;

    copyToClipboard(textToCopy);

    this.setState({
      ...this.state,
      copiedText: true,
    });

    setTimeout(() => {
      this.setState({
        ...this.state,
        copiedText: false,
      });
    }, 800);
  };

  render() {
    const {
      to,
      photos,
      useCarousel,
      disablePhotoCount,
      tags,
      title,
      date,
      stats,
      caption,
      className,
      hasSelfTour,
      has3DTour,
      textToCopy,
      hideStatsView,
      showViewWithTitle,
      bottomChips,
    } = this.props;

    const { preloadAllSlideshowImages, copiedText } = this.state;

    const statsTo = [];
    for (let i = 0; i < (stats || []).length; i += 1) {
      statsTo.push(<span key={stats[i]}>{stats[i]}</span>);
      if (i + 1 !== stats.length) {
        statsTo.push(
          <span key={i} className="separator">
            |
          </span>,
        );
      }
    }

    const SrLinkOrDiv = to ? SrLink : 'div';

    return (
      <div className={classnames('SrPartnerListingCard', className)}>
        <div className="cardHeader">
          {!useCarousel && (
            <SrLinkOrDiv to={to}>
              <div
                className="listingPicture"
                style={photos[0] ? { backgroundImage: `url("${photos[0]}")` } : {}}
              />
            </SrLinkOrDiv>
          )}
          {useCarousel && (
            <SrPhotosCarousel
              photos={photos}
              preloadedPhotos={preloadAllSlideshowImages ? photos : photos.slice(0, 3)}
              disablePhotoCount={disablePhotoCount}
            />
          )}
          <div className="listingStatusContainer">
            {!Array.isArray(tags)
              ? null
              : tags.map(({ label, theme, className }, index) => (
                  <span
                    key={index} // eslint-disable-line react/no-array-index-key
                    className={classnames('listingStatus', theme, className)}
                  >
                    {label}
                  </span>
                ))}
          </div>
          <div className="listingDetails">
            {!Array.isArray(bottomChips)
              ? null
              : bottomChips.map(({ label, theme, className }) => (
                  <span key={label} className={classnames('listingStatus', theme, className)}>
                    {label}
                  </span>
                ))}
            {(hasSelfTour || has3DTour) && (
              <div className="icons">
                {hasSelfTour && <SrIcon className="label-self-tour-bolt-yellow" />}
                {has3DTour && <SrIcon className="label-3d-tour-orange" />}
              </div>
            )}
            {caption && <div className="caption">{caption}</div>}
          </div>
        </div>
        {textToCopy && (
          <SrFlex
            bgColor="grey200"
            height="47px"
            align="center"
            paddingLeft="20px"
            paddingRight="18px"
            justify="between"
          >
            <div onClick={this._onCopyClick} className="textToCopyContainer">
              <SrBox marginRight="4px">
                <SrText weight="700" fontSize="14px" whiteSpace="nowrap">
                  Apply link:
                </SrText>
              </SrBox>
              <div className="textToCopy">
                <SrText weight="500" fontSize="14px">
                  {textToCopy}
                </SrText>
              </div>
            </div>
            <SrButton
              maxHeight="30px"
              minWidth="61px"
              className="listingCopyButton"
              heightType={SR_BUTTON_HEIGHT_SHORTER}
              theme={SR_BUTTON_THEME_ADOBE_YELLOW_TENANT_SCREENING_LISTING}
              fontSizeType={SR_BUTTON_FONT_SIZE_SMALL}
              onClick={this._onCopyClick}
            >
              {copiedText ? 'Copied' : 'Copy'}
            </SrButton>
          </SrFlex>
        )}
        <SrLinkOrDiv to={to}>
          <div className="cardBottom">
            <div className="row">
              <span className="title">{title}</span>
              {date && <span className="lastActiveDate">{date}</span>}
              {showViewWithTitle && <span className="viewMore">View</span>}
            </div>
            {!hideStatsView && (
              <div className="row">
                <div className="stats">{statsTo}</div>
                <span className="viewMore">View</span>
              </div>
            )}
          </div>
        </SrLinkOrDiv>
      </div>
    );
  }
}

SrPartnerListingCard.displayName = 'SrPartnerListingCard';

export default SrPartnerListingCard;
